<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="headerWrap">IMPORT GUESTS</h2>
         <div class="closeMessageModalWrapper">
          <close-icon @closeEvent="close" :dark="true"></close-icon>
        </div>
      </div>
      <div class="modal-body">
        <p>
          Import guests like this: <strong>First name, Last name, email, phone</strong>
          (using comma as separator)
          <br>
          or cut-and-paste directly from Excel
        </p>
        <textarea id="importTextArea" rows="20" cols="100" class="importTextArea" v-model="customerListText"></textarea>
        <div class="button-row">
          <button-global text="FAQ" size="large" type="neutral" @eventPassed="showFaq = true"></button-global>
          <button-global text="IMPORT" type="positive" @eventPassed="importGuests" :disabled="!contentValid"></button-global>
        </div>
      </div>
    </div>
    <div class="faq-modal" v-if="showFaq">
      <div class="faq-modal-content">
        <h3>FAQ - IMPORT GUESTS</h3>
        <div class="faq-modal__description">
          <p class="question"><strong>I only have first name and email?</strong></p>
          <p>If you only have first name and email, you can enter it in your list like this: First name, , email,</p>
          <p class="question"><strong>How to copy from excel?</strong></p>
          <p>
          In Excel, you mark the guests and press "copy". Then you simply paste it into the import-box here.<br>
          Dont't worry if it looks a bit odd when pasting. Everything should be fine.
          </p>
        </div>
        <button-global text="OK" type="positive" @eventPassed="showFaq = false"/>
      </div>
    </div>
  </div>
</template>

<script>
  import CloseIcon from '@/components/GlobalComponents/CloseIcon'
  import ButtonGlobal from '@/components/GlobalComponents/ButtonGlobal'
  import bus from '@/bus.js'
  import { db, functions } from '@/firebase'

  export default {
   components: {
    CloseIcon,
    ButtonGlobal
  },
  data () {
    return {
      contentValid: true,
      customerListText: '',
      maxSeats: 0,
      guestList: [],
      occupiedSeats: [],
      showFaq: false,
   }
  },
  created() {

    // OCCUPIED SEATS
    db.ref(`rooms/${this.$customerId}/${this.$hotelId}/`).once('value')
      .then(snapshot => {
        let occupiedSeats = []
        snapshot.forEach(function (data) {
          let room = data.val()
          if(!room.available) {
            occupiedSeats.push(room.roomnumber)
          }
        })
        this.occupiedSeats = occupiedSeats
      })

    // MAX SEATS
    db.ref(`customers/${this.$customerId}/numGuests`).once('value')
      .then(snapshot => {
        this.maxSeats = snapshot.val() || 0
      })
  },
  methods: {
    close() {
      bus.$emit('closeImportGuests')
    },
    parseText() {
      const validemail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
      // const headers = allTextLines[0].split(/[\t,;]/) // No headers support yet
      const allTextLines = this.customerListText.trim().split(/\r\n|\n/)

      for (let i = 0; i < allTextLines.length; i++) {
        const data = allTextLines[i].split(/[\t,;]/g) // Split on tabs, commas, or semicolons
        
        const guest = {
          "firstname": data[0].trim() || null, 
          "lastname": data[1].trim() || null, 
          "email": data[2].trim() || null, 
          "phone": data[3] || null
        }

        if (data.length === 4) {
          
          // Email field is empty
          if (data[2].trim().length === 0) {
            this.guestList.push(guest)
          } else {
            // TODO: improve handling of invalid emails, the loop does not stop on invalid emails
            if(guest.email.match(validemail)) {
              this.guestList.push(guest)
            } else {
              this.$swal("Invalid Email", `This email is not valid: ${guest.email}`, "warning")
            }
          }

        } else if (data.length === 3) { 
          if(guest.email.match(validemail)) {
            this.guestList.push(guest)
          } else {
            this.$swal("Invalid Email", `This email is not valid: ${guest.email}`, "warning")
          }
        } else {
          // We still want to import guests that do not have phones and emails, since this can later be updated.
          this.guestList.push(guest)
        }
      }
    },
    importGuests() {
      this.parseText()
      if(this.guestList.length) {
        this.$swal({
          title: 'Importing guests',
          text: 'Please note that this might take a while depending on the amount of guests being imported.',
          confirmButtonText: 'Start importing',
          allowOutsideClick: false,
          preConfirm: () => {
            this.$swal.showLoading();
            let checkinPromises = [];
            this.guestList.forEach(guest => {
              for (let roomNo = 1; roomNo <= this.maxSeats; roomNo++) {
                if(!this.occupiedSeats.includes(roomNo.toString())) {
                  let checkinPromise = this.checkinGuest(roomNo.toString(), guest)
                  this.occupiedSeats.push(roomNo.toString())
                  checkinPromises.push(checkinPromise)
                  break
                }
              }
            })
            return Promise.all(checkinPromises);
          }
        })
        .then(() => {
          this.$swal.hideLoading();
          this.$toastEvents.push({
            type: "positive",
            title: "Success",
            content: "Guests have been checked in",
            id: +new Date(),
          });
          this.close();
        })
      }
    },
    checkinGuest(roomNo, guest) {
      return functions.httpsCallable('manualGuestRegister')({
        customer_id: this.$customerId,
        hotel_id: this.$hotelId,
        action_type: 'checkin',
        guest_name: guest.firstname,
        guest_lastname: guest.lastname,
        guest_email: guest.email,
        guest_number: guest.phone,
        room_number: roomNo
      }).catch( () => {
        this.$swal('A problem occurred', 'Please try again later', 'error')
      })
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1, h2, h3, h4, p {
  color: #707070;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
}
.modal, .faq-modal {
  position: fixed;
  z-index: 910;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
}
.faq-modal {
  background-color: rgba(0,0,0,0.6);
}
.closeMessageModalWrapper {
  position: absolute;
  top: 0;
  right: 5px;
}
/* Modal Content */
.modal-content, .faq-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
  margin: 35px auto auto;
  padding: 25px;
  width: 90%;
  height: 90%;
  border: 1px solid #707070;
  border-radius: 15px;
}
.faq-modal-content {
  margin: 0px auto auto;
  width: 50%;
  min-height: 65%;
  height: auto;
  transform:translateY(-50%);
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.faq-modal__description p {
  margin: 0;
}
.faq-modal__description .question {
  margin: 5px 0;
}
.faq-modal-content h3 {
  font-size: 24px;
  margin: 0;
}
h2.headerWrap {
  margin-top: 10px;
  font-size: 32px;
  font-weight: 100;
  text-align: center;
}
.modal-body {
  height: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal-body p {
  text-align: center;
}
.importTextArea {
  resize: none;
  height: 300px;
  margin-bottom: 25px;
  border-radius: 8px;
  border: 1px solid #707070;
  transition: 0.1s ease-in;
  outline: 0;
}
.button-row {
  display: flex;
  justify-content: center;
}
#helptext {
  text-align: left;
}

@media screen and (max-width: 1025px) {
 .modal-body {
   flex-direction: column;
   align-items: center;
 }
 h2.headerWrap {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: 100;
}
}
@media screen and (max-width: 769px) {
  h2.headerWrap {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 24px;
  }
  .importTextArea {
    max-width: 20%;
  }
}
</style>
